import React, { useContext, useMemo } from 'react';
import {
  WorkspaceSelector,
  WorkspaceDropdownItemProps,
} from '@vimily/bonjoro-ui-components-v2/WorkspaceSelector';

import Workspace from '../Types/Workspace';
import WorkspaceContext from '~/App/Contexts/WorkspaceContext';
import { DropdownSelectorBodyProps } from '@vimily/bonjoro-ui-components-v2/dist/components/DropdownSelector';

export type WorkspaceDropdownProps = {
  onWorkspaceChange: (workspace: Workspace | null) => void;
  selectedWorkspace?: Workspace | null;
  hideAllOption?: boolean;
  label?: string;
  showLabelAsSelected?: boolean;
  className?: string;
  width?: number;
  dropdownBodyProps?: DropdownSelectorBodyProps;
};

export default function WorkspaceDropdown({
  onWorkspaceChange,
  hideAllOption,
  label = 'All',
  showLabelAsSelected,
  className,
  selectedWorkspace,
  width = 200,
  dropdownBodyProps,
}: WorkspaceDropdownProps) {
  const { workspaces } = useContext(WorkspaceContext);

  const workspaceItems: WorkspaceDropdownItemProps[] = useMemo(() => {
    const workspace: WorkspaceDropdownItemProps[] =
      workspaces?.map((workspaceItem) => {
        return {
          name: workspaceItem.name,
          category: workspaceItem.type,
          active: !!(
            selectedWorkspace && selectedWorkspace.id == workspaceItem.id
          ),
          onClick: () => onWorkspaceChange(workspaceItem),
        };
      }) ?? [];

    const allOption = hideAllOption
      ? []
      : [
          {
            name: 'All',
            onClick: () => onWorkspaceChange(null),
            active: selectedWorkspace === null,
          },
        ];

    return [...allOption, ...workspace];
  }, [workspaces, selectedWorkspace, onWorkspaceChange]);

  const activeItemLabel = selectedWorkspace?.name ?? label;

  return (
    <WorkspaceSelector
      className={`my-0 h-10 ${className ?? ''}`}
      bodyText={showLabelAsSelected ? label : activeItemLabel}
      items={workspaceItems}
      dropdownProps={{
        containerClassName: 'z-[100]',
      }}
      onViewAllClick={() => (window.location.href = '/workspaces')}
      onAddNewClick={() => (window.location.href = '#/c/create')}
      bodyWidth={width}
      dropdownWidth={250}
      dropdownBodyProps={dropdownBodyProps}
    />
  );
}
